import { DEFAULT_DATA_FILL_COLOR, DEFAULT_DATA_FONT_COLOR, DEFAULT_HEADERS_FILL_COLOR } from "./config";
import {
  DISABLED_BUTTON_TO_UPDATE_FILL_COLOR,
  DISABLED_BUTTON_TO_UPDATE_FONT_COLOR,
  UPDATE_BUTTON_IDX,
} from "./producerServices/constants";

interface ResetTableColorsArgs {
  table: Excel.Table | string;
  worksheet?: string;
  isDataProducer?: boolean;
}

export const resetTableColors = async ({ table, worksheet, isDataProducer = false }: ResetTableColorsArgs) => {
  try {
    if (typeof table === "string") {
      if (!worksheet) throw new Error("Worksheet name is required");

      await Excel.run(async (context) => {
        const sheet = context.workbook.worksheets.getItem(worksheet);
        const tableFromWorksheet = sheet.tables.getItem(table);
        resetTableColors({ table: tableFromWorksheet, isDataProducer: true });
      });

      return;
    }

    table.getHeaderRowRange().format.fill.color = DEFAULT_HEADERS_FILL_COLOR;
    table.getHeaderRowRange().format.font.color = DEFAULT_DATA_FONT_COLOR;
    table.getDataBodyRange().format.fill.color = DEFAULT_DATA_FILL_COLOR;
    table.getDataBodyRange().format.font.color = DEFAULT_DATA_FONT_COLOR;

    if (!isDataProducer) return;

    const actionButton = table.columns.getItemAt(UPDATE_BUTTON_IDX).getDataBodyRange();

    actionButton.format.fill.color = DISABLED_BUTTON_TO_UPDATE_FILL_COLOR;
    actionButton.format.font.color = DISABLED_BUTTON_TO_UPDATE_FONT_COLOR;
  } catch (error) {
    console.error(error);
  }
};
